import Tutorial from './Tutorial';
import common from '../../common';
import {translate} from '../../utils';
import MorphCommand from '../../commands/MorphCommand';
import JumpCommand from '../../commands/JumpCommand';
import WalkCommand from '../../commands/WalkCommand';

export default class TutorialLevel12 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();

		let lastTween = null;

		if (this.stage === 0) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 300, 130);
			common.focusOverlay.setFocus(25, 65, 300, 85);

			this._commands.ui.add.interactive = false;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE12.SELECT_CANNONBOLT');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({x: 0.85, y: 0.85}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({rotation: -15 * PIXI.DEG_TO_RAD}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 1) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 450, 130);
			common.focusOverlay.setFocus(25, 65, 600, 85);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE12.SELECT_CANNONBOLT');
			this.signals.update.dispatch();

			this._commands.commands[1].interactive = false;
			this._commands.commands[1].canChangeVariable = false;

			if (this._commands.selector) {
				this._commands.selector.children[1].interactive = false;
				this._commands.selector.children[3].interactive = false;
			}

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({x: 0.85, y: 0.85}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({rotation: -15 * PIXI.DEG_TO_RAD}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 2) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 300, 250);
			common.focusOverlay.setFocus(25, 205, 300, 85);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE12.SELECT_FOURARMS');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({x: 0.85, y: 0.85}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({rotation: -15 * PIXI.DEG_TO_RAD}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 3) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 + 550, 250);
			common.focusOverlay.setFocus(25, 205, 600, 85);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE12.SELECT_FOURARMS');
			this.signals.update.dispatch();

			this._commands.commands[3].interactive = false;
			this._commands.commands[3].canChangeVariable = false;

			if (this._commands.selector) {
				this._commands.selector.children[1].interactive = false;
				this._commands.selector.children[2].interactive = false;
			}

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({x: 0.85, y: 0.85}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({rotation: -15 * PIXI.DEG_TO_RAD}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 4) {
			this._commands.ui.add.interactive = true;
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.visible = false;
			common.focusOverlay.visible = false;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE12.FINISH');
			this.signals.update.dispatch();
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 0.5, () => {
					this.play();
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();

		for (let i = 0; i < 4; i++) {
			let command = null;
			if (i === 0 || i === 2) {
				command = new MorphCommand();
			} else if (i === 1) {
				command = new JumpCommand();
			} else if (i === 3) {
				command = new WalkCommand();
			}

			command.template = false;
			command.grabbable = false;
			command.locked = true;
			command.placed = true;
			this._commands.commandContainer.addChild(command);
			command.x = 169;
			command.setText(command.defaultVariable);
			command.variable = command.defaultVariable;

			for (const comm of this._commands.commands) {
				comm.slotPosition.set(comm.position.x, comm.position.y);
			}

			this._commands.commands.splice(i + 1, 0, command);
			this._commands.resize();

			command.signals.pickup.detachAll();

			if (i === 0 || i === 2) {
				command.interactive = true;
				command.canChangeVariable = true;
				command.signals.touch.add(this._commands.onCommandTouch, this._commands);
				command.signals.onVariableTouch.add(this._commands.onVariableTouch, this._commands);
			}

			if (i === 3) {
				command.variable = 3;
				command.defaultVariable = 3;
				command.setText(command.variable);
			}
		}
	}
}
